import React from "react";

interface IProps {
    options: string[];
}

export const SelectOptions = ({ options }: IProps): React.JSX.Element => {
    return (
        <>
            {options.map((option) => {
                return (
                    // TODO(i18n): Translate option labels with t tagged template: {t`${option}`}
                    <option key={option} value={option}>
                        {option}
                    </option>
                );
            })}
        </>
    );
};
